import {
  CommonTrackingData,
  getCommonTrackingData,
  trackingModelIdSplitter,
  VwTrack,
  VwTrackingEvents,
} from '@volkswagen-onehub/vw-e-mobility-feature-app-commons';
import {
  TrackingFunctions,
  TrackingEvent,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {TariffsTrackingCtx} from '@volkswagen-onehub/whitelabel-e-mobility-tariffs-feature-app';

const getCommonData = ({
  tenantConfiguration,
  selectedModel,
  selectedTrim,
}: TariffsTrackingCtx): CommonTrackingData => {
  const [trackingModelId, trackingModelTrimFeatures] = trackingModelIdSplitter(
    selectedModel?.id || ''
  );

  return getCommonTrackingData(!!tenantConfiguration.global?.commercial, {
    EquipmentlineName: selectedTrim?.trimId,
    CarlineId: selectedModel?.carlineId,
    CarlineName: selectedModel?.carlineName,
    SalesgroupId: selectedModel?.salesgroupId,
    SalesgroupName: selectedModel?.salesgroupName,
    ModelId: trackingModelId.length > 0 ? trackingModelId : undefined,
    ModelTrimFeatures:
      trackingModelTrimFeatures.length > 0
        ? trackingModelTrimFeatures
        : undefined,
    ModelName: selectedModel?.name,
    EnginePowerHPKW: selectedModel?.engine,
  });
};

export function getTariffsTrackingFunctions(
  track: VwTrack
): TrackingFunctions<TariffsTrackingCtx> {
  return {
    [TrackingEvent.TariffMoreInfoButtonClick]: (
      {tariffName, tariffCtaLink},
      ctx
    ) => {
      track(VwTrackingEvents.VWBasic_VehicleButton_Click, getCommonData(ctx), {
        eventInfo: {
          contentId: tariffName,
        },
        link: {
          name: tariffName,
          url: tariffCtaLink,
        },
      });
    },
    [TrackingEvent.TariffPdfDownloadButtonClick]: ({file, link}, ctx) => {
      track(VwTrackingEvents.VWBasic_Download_Click, getCommonData(ctx), {
        file,
        link,
      });
    },
  };
}
